import { OfferData } from './offer.type';

export interface StepupInfo {
  stepsUpId: number;
  name: string;
  description: string;
  isPublished: boolean;
  startDate: string;
  endDate: string;
  imageUrl: string;
  launchTimes: number;
  slotTimer: number;
  updatedAt: string;
  createdAt: string;
}

export interface LatestStepUpResponse {
  data: Partial<StepupInfo>;
}

export interface StepupOffer {
  offerId: string;
  offerData: OfferData;
  stepsUpDetailId: number;
  orderId: number;
}

export interface StepupResponse {
  data: {
    stepsUpInfo: StepupInfo;
    offers: StepupOffer[];
  };
}

export interface StepupUserStatus {
  data: {
    claimedItems: number | undefined;
  };
}

export enum OfferTypeEnum {
  AlternativeCurrency = 'AlternativeCurrency',
  Standard = 'Standard',
}

export interface StepupLaunchHistory {
  id: number;
  userId: string;
  stepsUpId: number;
  launchTimes: number;
  updatedAt: string;
  createdAt: string;
}

export interface PurchasingStepupOffer {
  stepupId: string;
  stepupOffer: StepupOffer;
  paymentId: string | undefined;
  transactionId: string | undefined;
  isPaymentConflicted?: boolean;
}

interface UsePurchaseStepupOfferProps {
  refetchStatusInterval: number;
  stepsUpId: number;
  onVerifySuccess: () => void;
  onInsufficientWebcoins: () => void;
}

interface UsePurchaseStepupOfferReturn {
  startPurchase: (payload: {
    stepupId: string;
    stepupOffer: StepupOffer;
  }) => void;

  isPaying: boolean;
  isPostPaymentVerifying: boolean;
  isPreparingPayment: boolean;

  purchasingStepupOffer: PurchasingStepupOffer | null;
  clearPersistentPurchasingOffer: () => void;
  startCancelPayment?: () => void;
  isCancelingPayment?: boolean;
}

export type UsePurchaseStepup = (
  props: UsePurchaseStepupOfferProps
) => UsePurchaseStepupOfferReturn;
